// extracted by mini-css-extract-plugin
module.exports = {"tagLabel":"opt-in-label_tagLabel_2ZXUx","tagHint":"opt-in-label_tagHint_35Tdp"};